export interface ModifierColor {
  label: string;
  value: string | null;
  color: string | null;
}

export const MODIFIER_COLORS: ModifierColor[] = [
  { label: 'NONE', value: null, color: null },
  { label: 'Teal', value: 'teal', color: '#009688' },
  { label: 'Green', value: 'green', color: '#43A047' },
  { label: 'Pink', value: 'pink', color: '#EC407A' },
  { label: 'Purple', value: 'purple', color: '#5E35B1' },
  { label: 'Blue', value: 'blue', color: '#0057B2' }
];

export function getModifierColor(
  value: string | null
): ModifierColor | undefined {
  return MODIFIER_COLORS.find((color) => color.value === value);
}
